function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("polygon", {
  id: "shape",
  className: "st0",
  points: "133.5,41.4 33.2,41.4 41.2,49.4 "
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "n",
  className: "st0",
  d: "M149.6,36.3v-16c0-3,2.1-5.5,5.1-5.5s5.1,2.5,5.1,5.5v16h6.2v-16c0-6.6-4.5-11.9-11.1-11.9 c-3,0-5.3,1.7-5.3,1.7V9h-6.2v27.2L149.6,36.3L149.6,36.3z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  id: "e",
  className: "st0",
  d: "M129.1,8.3c-7.2,0-12.3,6.3-12.3,14.3c0,8.4,6.4,14.3,12.9,14.3c3.3,0,7.4-1.1,10.9-6.1l-5.5-3.2 c-4.2,6.2-11.3,3.1-12.1-3.2h17.8C142.4,14.8,136.1,8.3,129.1,8.3z M134.5,19.1h-11.1C124.7,12.8,133.3,12.4,134.5,19.1z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  id: "t",
  className: "st0",
  d: "M114.8,29.8c-0.6,0.4-1.3,0.7-2.1,0.7c-1,0-2.9-0.8-2.9-3.3V15.5h5.3V9h-5.3V2.2h-6.2V9h-3.3v6.5h3.3 v11.7c0,6.1,4.6,9.7,9.2,9.7c1.7,0,4.1-0.6,6-1.7L114.8,29.8z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  id: "u",
  className: "st0",
  d: "M92,9v16c0,3-2.1,5.5-5.1,5.5S81.8,28,81.8,25V9h-6.2v16c0,6.6,4.5,11.9,11.1,11.9c3,0,5.3-1.7,5.3-1.7 v1h6.2V9H92z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("polygon", {
  id: "k",
  className: "st0",
  points: "64,21.8 74.6,9 66,9 58.5,18.5 58.5,0 52.2,0 52.2,36.3 58.5,36.3 58.5,25.1 67.7,36.3  76.3,36.3 "
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  id: "a",
  className: "st0",
  d: "M42.5,9v1.2C40.6,9,39,8.3,36.7,8.3c-7,0-12.4,6.4-12.4,14.3s5.3,14.3,12.4,14.3c2.3,0,4-0.7,5.8-1.9 v1.2h6.2V9H42.5z M36.6,30.4c-3.5,0-6-3.4-6-7.7s2.5-7.7,6-7.7s5.9,3.4,5.9,7.7C42.6,27,40.1,30.4,36.6,30.4z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  id: "R",
  className: "st0",
  d: "M6.5,36.3V25.7H11l7.9,10.5H27l-9.6-12.7c3-2.1,4.9-5.6,4.9-9.6c0-6.5-5.3-11.7-11.7-11.7H0v34L6.5,36.3 L6.5,36.3z M6.5,8.7h4.2c2.9,0,5.3,2.4,5.3,5.3s-2.4,5.3-5.3,5.3H6.5V8.7z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "logo",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 165.9 49.4",
    style: {
      "enableBackground": "new 0 0 165.9 49.4"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

export default __webpack_public_path__ + "static/media/rakuten.07aedc97.svg";
export { SvgComponent as ReactComponent };